import React from "react";

// class SCErrorBoundary.js extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state = { hasError: false };
//     }
//
//     static getDerivedStateFromError(error) {
//         // Update state so the next render will show the fallback UI.
//         return { hasError: true };
//     }
//
//     componentDidCatch(error, info) {
//         // You can also log the error to an error reporting service
//         //logErrorToMyService(error, info);
//     }
//
//     render() {
//         if (this.state.hasError) {
//             // You can render any custom fallback UI
//             return <h1>Something went wrongggggggggggggggggggggggggggggggggggggg.</h1>;
//         }
//
//         return this.props.children;
//     }
// }

class TErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            info: null,
        };
    }
    componentDidCatch(error, info) {
        this.setState({
            hasError: true,
            error: error,
            info: info,
        });
    }
    render() {
        if (this.state.hasError) {
            return (
                <div>
                    <h1>Oops, something went wrong :(</h1>
                    <p>The error: {this.state.error.toString()}</p>
                    <p>Where it occured: {this.state.info.componentStack}</p>
                </div>
            );
        }
        return this.props.children;
    }
}

export default TErrorBoundary;
